export const getUpdatedFormDataWithFilledValues = (formFieldsData = {}) =>
  Object.keys(formFieldsData).reduce((acc, key) => {
    const field = formFieldsData[key];

    acc[key] =
      typeof field?.filledValue === "string"
        ? field.filledValue.trim()
        : field?.filledValue;

    return acc;
  }, {});
